import styled, { css } from 'styled-components';
import {
  PurchaseHeaderLogo,
  CarvanaLogoHorizontal
} from '@carvana/purchase-icons';

type HeaderWrapperProps = {
  showPaddingOnMobile: boolean;
};

type PurchaseHeaderWrapperProps = {
  isMobile: boolean;
};

export const HeaderWrapper = styled.div<HeaderWrapperProps>`
  width: 100%;
  padding-top: ${props => (props.showPaddingOnMobile ? '49px' : '0px')};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  -webkit-font-smoothing: antialiased;

  a {
    text-decoration: none;
  }

  @media (min-width: ${props => props.theme.breakpoints.sm}px) {
    padding-top: 0px;
  }
`;

const StickyMobileHeader = css`
  position: sticky;
  position: '-webkit-sticky';
  top: 0;
  z-index: 10;
`;

export const PurchaseHeaderWrapper = styled.div<PurchaseHeaderWrapperProps>`
  width: 100%;
  background-color: #fff;
  height: 60px;
  border-bottom: 1px solid #d9dde9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  z-index: 100;
  ${props => props.isMobile && StickyMobileHeader}
`;

export const StyledPurchaseHeaderLogo = styled(PurchaseHeaderLogo)`
  cursor: pointer;

  body.using-mouse &:focus {
    outline: none;
  }
`;

export const StyledHorizontalCarvanaLogo = styled(CarvanaLogoHorizontal)`
  cursor: pointer;
  height: 36px;
  width: auto;

  body.using-mouse &:focus {
    outline: none;
  }
`;

export const HeaderLogoLink = styled.a.attrs({
  href: '/'
})<{ isNativeWebview?: boolean }>`
  ${props => props?.isNativeWebview && 'visibility: hidden;'}
`;

export const TimerCartWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  float: right;
`;

export const TimerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  border-radius: 61px;
  border: 1px solid #d9dde9;
  padding: 8px 12px;
  min-width: 108px;
  font-size: 14px;
  line-height: 16px;
  white-space: nowrap;
  font-family: Brandon Text;
`;

export const CartWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  border-radius: 61px;
  border: 1px solid #d9dde9;
  padding: 8px 12px;
  width: auto;
  font-size: 14px;
  line-height: 16px;
`;
